import { render, staticRenderFns } from "./RegoinType.vue?vue&type=template&id=6913148e"
import script from "./RegoinType.vue?vue&type=script&lang=js"
export * from "./RegoinType.vue?vue&type=script&lang=js"
import style0 from "./RegoinType.vue?vue&type=style&index=0&id=6913148e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports